/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleAnalyticsAggregateReportRowData
 */
export interface GoogleAnalyticsAggregateReportRowData {
    /**
     * 
     * @type {Date}
     * @memberof GoogleAnalyticsAggregateReportRowData
     */
    date?: Date;
    /**
     * 
     * @type {{ [key: string]: string | null; }}
     * @memberof GoogleAnalyticsAggregateReportRowData
     */
    dimensions?: { [key: string]: string | null; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GoogleAnalyticsAggregateReportRowData
     */
    metrics?: { [key: string]: string; };
}

/**
 * Check if a given object implements the GoogleAnalyticsAggregateReportRowData interface.
 */
export function instanceOfGoogleAnalyticsAggregateReportRowData(value: object): value is GoogleAnalyticsAggregateReportRowData {
    return true;
}

export function GoogleAnalyticsAggregateReportRowDataFromJSON(json: any): GoogleAnalyticsAggregateReportRowData {
    return GoogleAnalyticsAggregateReportRowDataFromJSONTyped(json, false);
}

export function GoogleAnalyticsAggregateReportRowDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleAnalyticsAggregateReportRowData {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'dimensions': json['dimensions'] == null ? undefined : json['dimensions'],
        'metrics': json['metrics'] == null ? undefined : json['metrics'],
    };
}

export function GoogleAnalyticsAggregateReportRowDataToJSON(json: any): GoogleAnalyticsAggregateReportRowData {
    return GoogleAnalyticsAggregateReportRowDataToJSONTyped(json, false);
}

export function GoogleAnalyticsAggregateReportRowDataToJSONTyped(value?: GoogleAnalyticsAggregateReportRowData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'] == null ? value['date'] : value['date'].toISOString().substring(0,10),
        'dimensions': value['dimensions'],
        'metrics': value['metrics'],
    };
}

